import React from 'react';
import './DesktopNavbar.css';
import { useLocation } from 'react-router-dom';
import { NavLink } from "react-router-dom";

interface DesktopNavbarProps {
  logo: string;
  subLogo: string;
  links: LinkItem[];
}

interface LinkItem {
  label: string;
  path: string;
}

const DesktopNavbar: React.FC<DesktopNavbarProps> = ({ logo, subLogo, links}) => {
  return (
    <header className='desktop-navbar sticky'>
        <div className="desktop-logo-container">
          <NavLink to="/">
            <div className="desktop-logo">{logo}</div>
            <div className="desktop-sublogo">{subLogo}</div>
          </NavLink>
        </div>
          <ul className="desktop-menu">
            {links.map((link) => {
              return (
                <li key={link.label}>
                  <NavLink to={link.path} className={({ isActive }) => isActive ? "active" : ""}>
                    {link.label}
                  </NavLink>
                </li>
              );
            })}
          </ul>
    </header>
  );
};

export default DesktopNavbar;
